import {Box, HStack, Icon, Text} from 'platform/foundation';
import {css} from 'styled-components';

import i18n from '@dms/i18n';

export function BlacklistFlag() {
  return (
    <Box backgroundColor="severity.danger" borderRadius="xSmall">
      <div
        css={css`
          padding: 1px 4px;
        `}
      >
        <HStack spacing={1} align="center">
          <Icon value="alert/error" color="general.white" size={3} />
          <Text size="xxSmall" color="white">
            {i18n.t('entity.vehicle.labels.blacklist')}
          </Text>
        </HStack>
      </div>
    </Box>
  );
}
